(function () {
    'use strict';

    angular.module("imApp").factory("choiceService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1214,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1819,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
